import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Suspense, lazy } from "react";
import { Layout } from "@/components/Layout";
import { PageSkeleton } from "@/components/PageSkeleton";
import Index from "./pages/Index";

const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const Contact = lazy(() => import("./pages/Contact"));
const CaseStudies = lazy(() => import("./pages/CaseStudies"));
const CaseStudyDetail = lazy(() => import("./pages/CaseStudyDetail"));
const Websites = lazy(() => import("./pages/services/Websites"));
const GbpSeo = lazy(() => import("./pages/services/GbpSeo"));
const Reputation = lazy(() => import("./pages/services/Reputation"));
const LeadGeneration = lazy(() => import("./pages/services/LeadGeneration"));
const Automation = lazy(() => import("./pages/services/Automation"));
const Reactivation = lazy(() => import("./pages/services/Reactivation"));
const FreeGbpAudit = lazy(() => import("./pages/FreeGbpAudit"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Layout>
            <Suspense fallback={<PageSkeleton />}>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/websites" element={<Websites />} />
                <Route path="/services/gbp-seo" element={<GbpSeo />} />
                <Route path="/services/reputation" element={<Reputation />} />
                <Route path="/services/lead-generation" element={<LeadGeneration />} />
                <Route path="/services/automation" element={<Automation />} />
                <Route path="/services/reactivation" element={<Reactivation />} />
                <Route path="/case-studies" element={<CaseStudies />} />
                <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/free-gbp-audit" element={<FreeGbpAudit />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </Layout>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
